import { useMutation, useQuery } from '@tanstack/react-query'
import { trpc } from '~/lib/trpc'

const FEED_STACK_STALE_TIME = 1000 * 60
const EMPTY_FEED_STACK_CUTOFF = '1970-01-01T00:00:00.000Z'

function getHomeFeedStackSummaryQueryOptions(cutoffAt: string) {
  return trpc.feed.getStackSummary.queryOptions(
    { cutoffAt },
    {
      staleTime: FEED_STACK_STALE_TIME,
    }
  )
}

function getHomeFeedNextCardQueryOptions(cutoffAt: string) {
  return trpc.feed.getNextCard.queryOptions(
    { cutoffAt },
    {
      staleTime: FEED_STACK_STALE_TIME,
    }
  )
}

export function useHomeFeedStackSummary(cutoffAt: string | null, enabled = true) {
  return useQuery({
    ...getHomeFeedStackSummaryQueryOptions(cutoffAt ?? EMPTY_FEED_STACK_CUTOFF),
    enabled: Boolean(cutoffAt) && enabled,
  })
}

export function useHomeFeedNextCard(cutoffAt: string | null, enabled = true) {
  return useQuery({
    ...getHomeFeedNextCardQueryOptions(cutoffAt ?? EMPTY_FEED_STACK_CUTOFF),
    enabled: Boolean(cutoffAt) && enabled,
  })
}

export function useMarkFeedStackCardSeen() {
  return useMutation(trpc.feed.markStackCardSeen.mutationOptions())
}

export function useHasFeedContent(enabled = true) {
  const { data: hasFeedContent = true, isLoading: isLoadingFeedContent } = useQuery(
    trpc.feed.hasContent.queryOptions(undefined, { staleTime: Infinity, enabled })
  )

  return {
    hasFeedContent,
    isLoadingFeedContent,
  }
}
